import React from 'react';
import Image from '../../../components/AppImage';
import { motion } from 'framer-motion';

const LifestyleSection = ({ currentLanguage }) => {
  const content = {
    EN: {
      title: "Live Your Life, Build Your Future",
      subtitle: "Use your PSPXpress card for everyday moments that matter",
      scenarios: [
        {
          title: "Shopping & Dining",
          description: "Enjoy meals out and retail therapy while building credit responsibly",
          image: "https://images.unsplash.com/photo-1541099649105-f69ad21f3246?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
        },
        {
          title: "Online Purchases",
          description: "Shop online with confidence using secure Mastercard technology",
          image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
        },
        {
          title: "Bill Payments",
          description: "Pay utilities, subscriptions, and monthly bills to build positive payment history",
          image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
        }
      ]
    },
    FR: {
      title: "Vivez votre vie, construisez votre avenir",
      subtitle: "Utilisez votre carte PSPXpress pour les moments quotidiens qui comptent",
      scenarios: [
        {
          title: "Achats et restauration",
          description: "Profitez des repas à l\'extérieur et de la thérapie par le shopping tout en construisant un crédit de manière responsable",
          image: "https://images.unsplash.com/photo-1541099649105-f69ad21f3246?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
        },
        {
          title: "Achats en ligne",
          description: "Achetez en ligne en toute confiance en utilisant la technologie Mastercard sécurisée",
          image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
        },
        {
          title: "Paiements de factures",
          description: "Payez les services publics, les abonnements et les factures mensuelles pour créer un historique de paiement positif",
          image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
        }
      ]
    }
  };

  const text = content?.[currentLanguage] || content?.EN;

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {text?.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {text?.subtitle}
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {text?.scenarios?.map((scenario, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-2xl mb-6">
                <Image
                  src={scenario?.image}
                  alt={scenario?.title}
                  className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300"></div>
              </div>

              <div className="text-center">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {scenario?.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {scenario?.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Youthful Call-to-Action */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
          className="text-center mt-16 bg-gradient-to-r from-primary to-blue-600 rounded-2xl p-8 text-white"
        >
          <h3 className="text-2xl font-bold mb-4">
            {currentLanguage === 'FR' ? 'Prêt à commencer votre parcours?' : 'Ready to start your journey?'}
          </h3>
          <p className="text-blue-100 mb-6">
            {currentLanguage === 'FR' ?'Rejoignez des milliers de jeunes adultes canadiens qui construisent leur avenir financier avec PSPXpress.' :'Join thousands of young Canadian adults building their financial future with PSPXpress.'
            }
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default LifestyleSection;